import { TONE_WORDS } from "./team";
import type { Tone } from "./team";
import own from "./team.module.css";

/**
 * The attention mark: **a diamond for expired, a circle for due**, nothing for
 * calm — and each says its meaning to a screen reader (STORY-181c), because
 * the shape is the difference and colour alone would not be.
 */
export function Mark({ tone }: { tone: Tone }): React.JSX.Element {
  return (
    <span className={own.mark} data-testid="attention-mark" data-tone={tone}>
      {tone !== "calm" && <span className={own.dot} data-tone={tone} aria-hidden="true" />}
      {tone !== "calm" && <span className={own.srOnly}>{TONE_WORDS[tone]}</span>}
    </span>
  );
}
